import { Button, Modal } from 'antd-mobile'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface DialogPayCompletedConfirmProps {
  open: boolean
  onBtnClick?: (selected: boolean) => void
}

const DialogPayCompletedConfirm: React.FC<DialogPayCompletedConfirmProps> = ({ open, onBtnClick }) => {
  const { t } = useTranslation()
  return (
    <Modal
      visible={open}
      closeOnMaskClick={true}
      maskClassName="__CustomMask__bg"
      content={
        <div className="px-2">
          <div className="text-center text-base font-medium px-2 pt-4 pb-6">{t('common.payCompletedConfirm')}</div>
          <div className="flex items-center gap-4">
            <Button
              type="button"
              className="grow-2 h-12 rounded-full text-[#682B01] text-base bg-gradient-to-r from-[rgba(254,153,33,0.1)] to-[rgba(255,66,59,0.1)] border-0"
              onClick={() => {
                onBtnClick?.(false)
              }}>
              {t('common.unpaid')}
            </Button>
            <Button
              type="button"
              className="grow-1 h-12 rounded-full text-white text-base bg-gradient-to-r from-[rgba(254,153,33,1)] to-[rgba(255,66,59,1)] border-0"
              onClick={() => {
                onBtnClick?.(true)
              }}>
              {t('common.paid')}
            </Button>
          </div>
        </div>
      }
    />
  )
}

export default DialogPayCompletedConfirm
